import {connect, useDispatch, useSelector} from "react-redux";
import React, {useCallback, useMemo, useRef, useEffect, useState} from "react";
import {currencyFormatter} from "../../../../config/formatter";
import {
	CAlert,
	CButton, CCol,
	CForm, CFormInput,
	CInputGroup, CInputGroupText,
	CRow
} from "@coreui/react";
import {AgGridReact} from "ag-grid-react";
import * as stockMethod from "../../../../api/method/stockMethod";

import {render, Printer, Text, Br, Line, Row, Cut} from "react-thermal-printer";
import dayjs from "dayjs";
import {DatePicker} from "antd";
import locale from "antd/es/date-picker/locale/ko_KR";
import * as o2Api from "../../../../api/api";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";
import {getBrand, getStoreWhere} from "../../../../api/api";
import {printerActions} from "../../../../redux-store/actions/printer";
import {cutStr, getTextLength, isKorean, lpad, rpad} from "../../../../util/stringUtil";

const SimpleStockManage = (props) => {
	const { user } = useSelector((props) => props.account);
	const { printer } = useSelector((props) => props.printer);
	const dispatch = useDispatch();
	const gridRef = useRef();
	const productBillGridRef = useRef();
	const [searchForm, setSearchForm] = useState({
		cmpCd: "", brandCd: "", storeCd: "",
		productCd: "",
		productNm: "",
		barcode: "",
		stockDt: dayjs()
	});
	const [error, setError] = useState({visible: false, message: ""});
	const [rowData, setRowData] = useState([]);
    const [isBtnDisable , setIsBtnDisable] = useState(false);
    const [brand, setBrand] = useState({brandCd: "", brandNm: ""});
    const [filterData, setFilterData] = useState([]);

	const defaultColDef = {
		width: 100,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};
	const [columnDefs] = useState([
		{field: "seq", headerName: "No", width: 50, editable: false, cellClass: "static-cell"},
		{field: "restProductCd", headerName: "상품코드", maxWidth: 120, editable: false, cellClass: "static-cell", cellStyle: {color: "blue", cursor: "pointer"}} ,
		{field: "productNm", headerName: "상품명", minWidth: 120, flex: 1, editable: false},
		{field: "barcode", headerName: "바코드", minWidth: 120, flex: 1, editable: false},
		{field: "price", headerName: "판매가", maxWidth: 100, valueFormatter: currencyFormatter, editable: false, cellClass: "number-cell"},
		{field: "currentStockQty", headerName: "현재고", maxWidth: 100, editable: false, cellClass: "number-cell"},
		{field: "todayStockSaleQty", headerName: "당일판매수량", maxWidth: 100, editable: false, cellClass: "number-cell"},
		{field: "yesterdayStockCurrentQty", headerName: "전일재고", maxWidth: 100, editable: false, cellClass: "number-cell"},
		{field: "todayStockInQty", headerName: "입고수량", maxWidth: 100, editable: true, cellClass: "number-cell"},
		{field: "todayStockOutQty", headerName: "반출수량", maxWidth: 100, editable: true, cellClass: "number-cell"}
	]);

	const [productBillColumnDefs] = useState([
		{headerName: "No", width: 70, valueGetter: "node.rowIndex + 1", cellClass: "static-cell"},
		{field: "productNm", headerName: "상품명", width: 600},
		{field: "price", headerName: "판매가", width: 100, valueFormatter: currencyFormatter, editable: false, cellClass: "number-cell"},
		{field: "todayStockInQty", headerName: "입고수량", width: 100, cellClass: "number-cell"},
		{field: "todayStockOutQty", headerName: "반출수량", width: 100, cellClass: "number-cell"}
	]);

	const search = () => {
		setError({
			visible: false, message: ""
		});

		const {cmpCd, brandCd, storeCd} = searchForm;
		if (storeCd.length === 0) {
			setError({
				visible: true, message: "매장은 필수로 선택하셔야 합니다."
			});
			return;
		}

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			stockDt: searchForm.stockDt.format("YYYYMMDD"),
			restProductCd: searchForm.restProductCd,
			productNm: searchForm.productNm,
			type: searchForm.type
		};

		try {
			props.setLoading(true);
			setIsBtnDisable(false);
			stockMethod.getErestSimpleStockList(params).then((result) => {
				props.setLoading(false);
				setRowData(result);

				// 입고나 반출이 있는 상품만
				const filter = result.filter(item => item.todayStockInQty !== 0 || item.todayStockOutQty !== 0);
				setFilterData(filter);

			});
		} catch (e) {
			props.setLoading(false);
			setError({visible: true, message: e.message});
		}
	};

	let updateRows = [];

	function onUpdate() {
		const {api} = gridRef.current;
		if (api === null) return;

		api.forEachNode(function (rowNode, index) {
			if (rowNode.data.edit) {
				updateRows.push(rowNode.data);
			}
		});
	}

	const save = () => {
        setIsBtnDisable(true);
		//console.log("저장버튼 클릭! ");

		setTimeout(() => {
			gridRef.current.api.stopEditing(); //row 쌓이는 시간

			// 딜레이를 주자
			setTimeout(() => {

				let pushData = updateRows;
                //console.log("나 1. >>> 실제 저장할 pushData :: ", pushData);
                updateRows = []; //그리드 row데이터 초기화 시킴

                //console.log("나. pushData.length ::: "  + pushData.length + "  /// updateRows.length ::: " + updateRows.length);

                //console.log("나 setTimeout. 실제 저장할 pushData.length ::: " ,pushData.length);
                //console.log("나 setTimeout. 그리드 쌓인 updateRows.length ::: " ,updateRows.length);
				if (pushData.length  === 0) {
					return; //변경된 row 없으면, api호출 안함
				}

				props.setLoading(true);

				o2Api.putStockList(pushData).then((result) => {
					const {responseBody, responseCode, responseMessage} = result.data;
					if (responseCode === "200") {
						//console.log("3. 저장완료");
						alert("처리되었습니다.");
						search();
					}
				})
				.catch((e) => {
					console.log("### error :: ", e.message);
					setIsBtnDisable(false);
				})
				.finally(() => {
					props.setLoading(false);
				})
			}, 199);
		}, 200);
        setIsBtnDisable(false);
	} //End save();

	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
	const gridStyle = useMemo(() => ({height: 500, width: "100%"}), []);

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
			}));
		}
	};

	const getUpdateRows = (e) => {
		const {cmpCd, brandCd, storeCd} = searchForm;
		const colId = e.column.colId;
		if (colId === "todayStockInQty") {
			if (e.oldValue !== e.newValue) {
				const data = {
					brandCd: brandCd,
					cmpCd: cmpCd,
					productCd: e.data.productCd,
					stockCd: "10",  // 입고
					stockDt: searchForm.stockDt.format("YYYYMMDD"),
					stockEaQty: e.data.todayStockInQty,
					stockPackQty: 0,
					stockQty: e.data.todayStockInQty,
					storeCd: storeCd
				}
				updateRows.push(data);
			}
		} else if (colId === "todayStockOutQty") {
			if (e.oldValue !== e.newValue) {
				const data = {
					brandCd: brandCd,
					cmpCd: cmpCd,
					productCd: e.data.productCd,
					stockCd: "29",  // 반출
					stockDt: searchForm.stockDt.format("YYYYMMDD"),
					stockEaQty: e.data.todayStockOutQty,
					stockPackQty: 0,
					stockQty: e.data.todayStockOutQty,
					storeCd: storeCd
				}
				updateRows.push(data);
			}
		}

		console.log(">>> update rows :: ", updateRows);
	}

	const onCellEditingStopped = (e) => {
		//setIsBtnDisable(false);
		getUpdateRows(e);
	}

    const onCellClicked = (e) => {
        switch (e.colDef.field) {
            case "restProductCd":
                onDetail(e.data);
                break;
        }
    };

    const onDetail = (data) => {
    	console.log("data ::: " , data);
        const {cmpCd, brandCd, storeCd} = searchForm;

        const params = "cmpCd=" + cmpCd + "&brandCd=" + brandCd + "&storeCd=" + storeCd+ "&productCd=" + data.productCd+ "&stockDt=" + searchForm.stockDt.format("YYYYMMDD");
        console.log("params : ", params)
        window.open("/#/stock/detail?" + params, "_detail", "width=800, height=600");
    };

	async function getStore() {
		const {cmpCd, brandCd, storeCd} = searchForm;
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			manageDiv: "0",
			userId: user.userId
		};

		const {data: result} = await getStoreWhere(params);
		const {responseBody, responseCode, responseMessage} = result;
		if (responseCode === "200") {
			if (responseBody != null) {
				return responseBody[0];
			}
			else return null;
		}
	}

	const onStockPrint = async () => {
		if (confirm("매장 재고현황을 출력하시겠습니까?")) {
			// 데이터 필터링 - 현재고가 있는 상품만
			const filterData = rowData.filter(item => item.currentStockQty !== 0);
			console.log(">>> 필터 출력 건수 :: ", filterData.length);

			if (filterData.length === 0) {
				alert("출력할 데이터가 없습니다. (현재고 0)");
				return;
			}

			if ("serial" in navigator) {
				const filters = []

				// 시리얼포트 선택
				try {
					console.log("### printerPort :: ", printer);
					let port;
					if (printer === null || printer === undefined) {
						port = await navigator.serial.requestPort({filters});
						await port.open({ baudRate: 9600 })
						// 포트 오픈 후에 해당 값을 담아둔다
						props.setPrinterPort(port);
					}
					else {
						port = printer;
					}

					props.setLoading(true);
					// 영수증 출력을 위한 점포정보 가져오기
					const storeInfo = await getStore();
					console.log("### storeInfo :: ", storeInfo);

					const receipt = (
						<Printer type={"epson"} width={42} characterSet={"korea"}>
							<Text align={"center"} bold={true} size={{ width: 2, height: 1 }}>재고현황</Text>
							<Br/>
							<Row left={<Text>{storeInfo.storeNm}</Text>} right={<Text>T:{storeInfo.telNo}</Text>} />
							<Text>대표 : {storeInfo.ownerNm}</Text>
							<Text>{storeInfo.addr1}</Text>
							<Line character={"="}/>
							<Text>{"상품                    입고  판매  현재고"}</Text>
							<Line />
							{filterData.map((item, idx) => {
								// 상품명 한글 체크, 자르기
								let productNm = item.productNm;
								if (getTextLength(productNm) > 24) productNm = rpad(cutStr(productNm, 0, 24), 24, " ");
								else productNm = rpad(productNm, 24, " ");
								// 현재고
								const currentStockQty = lpad(item.currentStockQty, 6, " ");
								// 입고
								const todayStockInQty = lpad(item.todayStockInQty, 6, " ");
								// 판매
								const todayStockSaleQty = lpad(item.todayStockSaleQty, 6, " ");
								return <Text key={idx}>{productNm}{todayStockInQty}{todayStockSaleQty}{currentStockQty}</Text>
							})}
							<Line character={"="}/>
							<Row left={"출력일자"} right={dayjs().format("YYYY-MM-DD HH:mm:ss")}/>
							<Br/>
							<Cut/>
						</Printer>
					)
                    const data: Uint8Array = await render(receipt);

					const writer = port.writable.getWriter();
					if (writer != null) {
						await writer.write(data);
						writer.releaseLock();

						// await port.close();
						props.setLoading(false);
					}
				}
				catch (ex) {
					alert("Exception :: " + ex.message);
				}
			} else {
				console.log("serial 미지원");
				alert("브라우저에서 SERIAL 출력을 지원하지 않습니다.\n다른 브라우저를 이용해 주세요.");
			}
		}
	}

	const setPrinterFriendly = (api) => {
		const eGridDiv = document.querySelector("#grid_product");
		eGridDiv.style.width = '';
		eGridDiv.style.height = '';
		api.setDomLayout("print");
	};

	const setNormal = (api) => {
		const eGridDiv = document.querySelector("#grid_product");
		eGridDiv.style.width = "700px";
		eGridDiv.style.height = "200px";
		api.setDomLayout();
	};

	const onProductBillPrint = () => {
		// 조회 카운트 계산
		if (filterData.length > 0) {
			// 브랜드 정보를 가져오자
			props.setLoading(true);

			getBrand(searchForm.cmpCd, searchForm.brandCd).then((result) => {
				const {responseBody, responseCode, responseMessage} = result.data;
				if (responseCode === "200") {
					// 성공
					props.setLoading(false);

					setBrand(responseBody);

					const api = productBillGridRef.current.api;
					dispatch({ type: 'set', sidebarShow: false })

					setPrinterFriendly(api);
					setTimeout( function () {
						print();
						setNormal(api);
						dispatch({ type: 'set', sidebarShow: true })
					}, 1000);
				}
			})
		}
		else {
			alert("먼저 자료 조회를 하셔야 합니다.");
		}
	}

	return (
		<div style={containerStyle}>
			<div className="d-grid d-md-flex justify-content-between" style={{marginBottom: 10}}>
				<h5 className={"hidden-print"}>매장 재고관리</h5>
			</div>
			{error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
			<div className={"hidden-print"}>
				<StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
				<div className={"row row-cols-lg-auto g-1 m-0 align-items-center"}>
					<CCol xs={12} sm={4}>
						<CInputGroup size={"sm"}>
							<CInputGroupText style={{width: 80}}>영업일자</CInputGroupText>
							<CInputGroupText style={{background: "white", height: 35}}>
								<DatePicker bordered={false}
											separator={"~"}
											placeholder={""}
											locale={locale}
											value={searchForm.stockDt}
											onChange={(dayjs, dateString) => {
												setSearchForm((state) => ({
													...state, stockDt: dayjs
												}));
											}}/>
							</CInputGroupText>
						</CInputGroup>
					</CCol>
					<CCol xs={12} sm={4}>
						<CInputGroup size={"sm"}>
							<CInputGroupText style={{width: 80}}>상품코드</CInputGroupText>
							<CFormInput id="productCd"
										style={{height: 35}}
										onKeyPress={(e) => {
											if (e.key === "Enter") {
												search();
											}
										}}
										onChange={(e) => {
											setSearchForm((state) => ({
												...state,
												restProductCd: e.target.value
											}));
										}}/>
						</CInputGroup>
					</CCol>
					<CCol xs={12} sm={4}>
						<CInputGroup size={"sm"}>
							<CInputGroupText style={{width: 80}}>상품명</CInputGroupText>
							<CFormInput id="productNm"
										style={{height: 35}}
										onKeyPress={(e) => {
											if (e.key === "Enter") {
												search();
											}
										}}
										onChange={(e) => {
											setSearchForm((state) => ({
												...state,
												productNm: e.target.value
											}));
										}}/>
						</CInputGroup>
					</CCol>
					<div className={"d-grid d-md-flex gap-1"}>
						<CButton style={{minWidth: 50, height: 35}} size={"sm"} color="primary" onClick={onProductBillPrint}>상품청구서</CButton>
						<CButton style={{minWidth: 50, height: 35}} size={"sm"} color="primary" onClick={onStockPrint}>출력</CButton>
						<CButton style={{minWidth: 50, height: 35}} size={"sm"} disabled={isBtnDisable}  color="primary" onClick={save}>저장</CButton>
						<CButton style={{minWidth: 50, height: 35}} size={"sm"} color="primary" onClick={search}>조회</CButton>
					</div>
				</div>
			</div>
			<div style={{height: 10}}/>
			<div className="ag-theme-alpine hidden-print" style={gridStyle}>
				<AgGridReact
					ref={gridRef}
					headerHeight={30}
					rowHeight={30}
					rowSelection={"single"}
					rowData={rowData}
					pagination={true}
					singleClickEdit={true}
					onCellEditingStopped={onCellEditingStopped}
                    onCellClicked={onCellClicked}
					suppressDragLeaveHidesColumns={true}
					defaultColDef={defaultColDef}
					columnDefs={columnDefs}>
				</AgGridReact>
			</div>

			<div id={"grid_product"} className={"ag-theme-alpine visible-print"} style={{width: "100%"}}>
				<h1><center><strong>편의점 상품청구서</strong></center></h1>
				<br />
				<h4>업소명 : {brand.brandNm.replaceAll("휴게소", "")}</h4>
				<h4>날짜 : {searchForm.stockDt.format("YYYY년 MM월 DD일")}</h4>
				<h4>담당자 : </h4>
				<br />
				<AgGridReact
					ref={productBillGridRef}
					animateRows={true}
					rowData={filterData}
					defaultColDef={defaultColDef}
					columnDefs={productBillColumnDefs}>
				</AgGridReact>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const {account, store, selected, printer} = state;
	return {
		account, store, selected, printer
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setPrinterPort: (printer) => {
			dispatch(printerActions.setPrinterPort(printer));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SimpleStockManage);
